import { IAction, IBooleanValueAction } from "../../../redux/actions";

// tslint:disable-next-line
export interface InGameMessage {
  text: string;
  url?: string;
}

export interface IMessage extends IAction {
  value: string | InGameMessage[];
}

export enum types {
  SET_TICKER_MESSAGE = "SET_TICKER_MESSAGE",
  SET_TICKER_HIDDEN = "SET_TICKER_HIDDEN",
  SET_ANIMATION_STOPPED = "SET_ANIMATION_STOPPED"
}

export const setTickerMessage = (value: string | InGameMessage[]): IMessage => {
  return {
    type: types.SET_TICKER_MESSAGE,
    value
  };
};

export const setTickerHidden = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_TICKER_HIDDEN,
    value
  };
};

export const setAnimationStopped = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_ANIMATION_STOPPED,
    value
  };
};
